import React from 'react';
import cx from './index.module.scss';
import DownloadButton from '../DownloadButton';

const GNB = ({onClick}) => {
  return (
    <div className={cx.wrap} >
      <button className={cx.text} onClick={onClick}>2019 대한민국 직장인 행복도<br/>Blind index of employee’s happiness</button>
      <DownloadButton />
    </div>
  );
};

export default GNB
